export default __webpack_public_path__ + "static/media/photo--sm--6.1b8366b3.jpg";